// Only for accessing bet slip in modules other than sport event details
// Dont Delete this if satisfying above condition
import { mapGetters } from 'vuex';
import { Collapse } from 'bootstrap';

export default{
    computed:{
        ...mapGetters(['chips','clickBetValue']),
        getClickBetValue() {
            return this.clickBetValue
        },
    },
    methods:{
        addBet(market, selection_type, r_index, divId, eventType) {
            if (this.betDetails && this.betDetails.betLoader) return;
            if (!this.$auth.status) {
                this.$errorToast(this.$t('login-msg-bet', 'Please Log In to place the bets'));
                this.$helper.openModal('#login-casino-btn')
                return
            } else {
                let user = this.$store.getters.stateUser;
                let marketRunners = eventType == 'inplay' ? this.inplayMarketOdds[market?.market_id] : this.upcomingMarketOdds[market?.market_id];
                if(!marketRunners || (marketRunners && !marketRunners.length)) {
                    this.$errorToast('Market is not active!');
                    return; // runners not found
                }
                let runner = marketRunners[r_index];
                if(!runner) {
                    this.$errorToast('Runner not active!');
                    return; // selected runner not found
                }
                this.betDetails = {};
                let odds = (runner.ex && runner.ex[selection_type == 'back' ? 'b' : 'l'] && runner.ex[selection_type == 'back' ? 'b' : 'l'][0]) ? runner.ex[selection_type == 'back' ? 'b' : 'l'][0].p : '';
                if(!odds) {
                    return;
                }
                this.setBetslipCount(market)
                this.betDetails['market'] = market;
                this.betDetails['odds'] = odds;
                this.betDetails['screen_odds'] = odds;
                this.betDetails['match_id'] = market.matchId;
                this.betDetails['min_stake'] = market.min_stake ? market.min_stake : 100;
                this.betDetails['max_stake'] = market.max_stake ? market.max_stake : 2000;
                this.betDetails['sport_id'] = market.sport_id;
                this.betDetails['eventId'] = market.event_id;
                this.betDetails['selection_type'] = selection_type;
                this.betDetails['runner_name'] = market.event_name;
                this.betDetails['bet_type'] = 'market';
                this.betDetails['accept_any_odds'] = user.accept_any_odds === undefined ? false : user.accept_any_odds;
                this.betDetails['runner'] = runner;
                this.betDetails['rIndex'] = r_index;
                this.betDetails['bet_time'] = Math.round(Date.now() / 1000)
                this.betDetails['bet_delay'] = market.bet_delay || 0;
                this.betDetails['market_id'] = market.market_id;
                this.betDetails['runner_selection_id'] = runner.sid;
                console.log('netDetails',this.betDetails, r_index,'market', market)
                console.log('---->', this.betDetails?.market_id, market?.market_id, this.betDetails?.market_id== market?.market_id)
                let clickbetActive = this.$store.getters.clickBetActive;
                // for unicon only ---------------------
                if(this.$refs.betSlip){
                    this.$refs.betSlip.showStakes = true;
                    this.$refs.betSlip.chips = JSON.parse(JSON.stringify(this.chips))
                }
                // ----------------------------------------
                if (this.getClickBetValue && clickbetActive) {
                    for (var i = 0; i < this.getClickBetValue.length; i++) {
                        if (this.getClickBetValue[i].isSelected) {
                            this.betDetails.stake = this.getClickBetValue[i].value;
                            this.showBetSlip(divId);
                            setTimeout(() => {
                                this.$refs.betSlip.calculationOfProfitLoss();
                                this.$refs.betSlip.saveBets();
                            }, 200)
                        }
                    }
                } else {
                    if(this.pastDivId != divId){
                        this.showBetSlip(divId);
                    }
                }
            }
            this.counterStartForCloseBet()
        },
        showBetSlip(divId) {
            this.pastDivId = divId
            if (!document.getElementById('bet-slip')) {
                this.$router.go();
            } else {
                document.getElementById(divId).insertAdjacentElement("afterend", document.getElementById('bet-slip'));
                if (!document.querySelector('#bet-slip.collapse.show')) {
                    this.$nextTick().then(() => {
                        let betCollapse = new Collapse(document.getElementById('bet-slip'));
                        betCollapse.show();
                    })
                    this.isBetSlipRendered = true;
                    this.counterStartForCloseBet();
                }
            }
        },
        counterStartForCloseBet() {
            clearInterval(this.betCloseSetTimeOut);
            this.betCloseSetTimeOut = setInterval(() => {
                var current_time = Math.round(Date.now() / 1000);
                if (current_time - this.betDetails.bet_time > 9) {
                    this.CancelBetSlip();
                }
            }, 1000);
        },
        CancelBetSlip() {
            this.pastDivId = null;
            setTimeout(() => {
                    this.betDetails = {};
            }, 400)
            const betSlip = document.getElementById('bet-slip');
            const betSlipSection = document.getElementById('betSlipSection');
            betSlipSection.appendChild(betSlip);
            let betCollapse = new Collapse(betSlip);
            
            // for unicon only --------------------
            setTimeout(()=>{
                this.$helper.closeModal('betplace-modal')
                if(this.$refs.betSlip){
                    if(this.$refs.betSlip?.delayInterval){
                        clearInterval(this.$refs.betSlip?.delayInterval);
                    }
                    this.$refs.betSlip.showStakes = true;
                    this.$refs.betSlip.chips = JSON.parse(JSON.stringify(this.$store.getters.chips))
                }
            },100)
            // ---------------------------------------
            betCollapse.hide();
            clearInterval(this.betCloseSetTimeOut);
        },
        setBetslipCount(market) {
            let user = { ...this.$store.getters.stateUser };
            let betslipCount = { ...(user.betslipCount && user.betslipCount.eventId == this.event_id ? user.betslipCount : { eventId: this.event_id }) };

            let betSlipObject = {
                exp: Math.round(Date.now() / 1000) + 180 // 180 seconds for 3 minutes
            };

            betslipCount[market.market_id] = betslipCount[market.market_id] || [];
            betslipCount[market.market_id].push(betSlipObject);
            this.$store.dispatch('setUser', { ...user, betslipCount });
        },
    }
}